import React from 'react';
import { FC } from 'react';
import { publicAssets } from '@utils/url.utils';
import {
    Person,
    PersonDetail,
    PersonImage,
    PersonMail,
    PersonName,
    PersonPhone,
    PersonPosition,
} from './TeamPerson.elements';

export interface TeamPersonProps {
    personKey: number;
    image: string;
    name: string;
    position: string;
    phones?: string[];
    mail: string;
    width?: number;
    withoutMargin?: boolean;
}

const TeamPersonTemplate: FC<TeamPersonProps> = ({
    personKey,
    image,
    name,
    position,
    phones = [],
    mail,
    width,
    withoutMargin,
}) => {
    return (
        <Person withoutMargin={withoutMargin}>
            <PersonImage width={width} src={publicAssets(image)} />
            <PersonDetail width={width}>
                <PersonName>{name}</PersonName>
                <PersonPosition>{position}</PersonPosition>
                {phones.map((phone: string, phoneKey: number) => (
                    <PersonPhone href={`href:${phone}`} key={phoneKey}>
                        {phone}
                    </PersonPhone>
                ))}
                <PersonMail href={`mailto:${mail}`}>{mail}</PersonMail>
            </PersonDetail>
        </Person>
    );
};

export default TeamPersonTemplate;
